// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__H4sXY","expireSoon":"styles_expireSoon__2wJ3i"};